import angular from 'angular';

import AccountSettingsComponent from './account.cmpt';

export default angular
    .module('application.scene.authorized.scene.settings.scene.account', [])
    .component(AccountSettingsComponent.selector, AccountSettingsComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('authorized.calendar.settings.account', {
        url: '/account?action',
        component: AccountSettingsComponent.selector
    });
}



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/settings/scene/account/index.js